import React, { useEffect, useState } from "react";
import { Calendar } from "react-multi-date-picker";
import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";

const weekDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]
const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

const MultSelectDate = (props) => {
    const [value, setValue] = useState(new Date())
    const [gravando, setGravando] = useState(false)

    async function handlePost() {
        setGravando(true)

        try {
            let _values = []
            for (let i = 0; i < props.value?.length; i++) {
                _values.push(props.value[i])
            }

            console.log("multSelectDate.values: ", _values)
            if (props.handlePost)
                await props.handlePost(_values)

            handleClose()
        } catch (error) {

        }

        setGravando(false)
    }

    // function handleDate() {
    //     console.log("value", value)
    //     for (let i = 0; i < value?.length; i++) {
    //         console.log(value[i].format("DD-MM-YYYY"))
    //     }
    // }

    function handleValue(e) {
        if (e?.preventDefault)
            e.preventDefault()

        console.log("value", e.target)
        // props.setValue([...props.value, e.target.value])
    }

    function handleClose() {
        console.log("close")
        if (props.handleCloseEv)
            props.handleCloseEv()
    }

    function GetCalendar() {
        return (
            <>
                <Calendar
                    value={value}
                    onChange={setValue}
                    multiple={true}
                    format="DD-MM-YYYY"
                    weekDays={weekDays}
                    months={months}
                />
                {/* <button style={{ marginLeft: "0px", marginTop: "5px" }} onClick={handleDate}>Send</button> */}
            </>
        );
    }

    return (
        <>
            {props.modal &&
                <Modal
                    size={props.size ? props.size : "sm"}
                    show={true}
                    onHide={handleClose}
                    centered
                    animation={false}
                    backdrop="static"
                >

                    <Modal.Body className="maxWidth750">
                        {gravando ? (
                            <div>Gravando registro(s)...</div>
                        ) : (
                            <>
                                <GetCalendar />
                                <div style={{ display: "flex", flexDirection: "row-reverse", marginTop: "5px" }}>
                                    <Button color="secondary" onClick={handleClose}>
                                        Fechar
                                    </Button>
                                    <Button color="success" onClick={handlePost} style={{ marginRight: "5px" }}>
                                        Gravar
                                    </Button>
                                </div>
                            </>
                        )}

                    </Modal.Body>
                    {/* <Modal.Footer>
                    
                </Modal.Footer> */}
                </Modal>}
            {!props.modal && <GetCalendar />}
        </>
    );
}

export default MultSelectDate;